import React from "react";
import {useSite} from "../context/SiteContext";
import {NAV} from "../data/siteData";
import {asset, GRAD, inkOn, onLight, TINT} from "../utils";
import Icon from "./common/Icon";

const Header = () => {
    const {headerRef, section, scrolled, menuOpen, setMenuOpen, go, openApp} = useSite();
    // Transparent only over the hero video, before scrolling, with the mobile menu shut.
    const clear = !scrolled && !menuOpen;
    const navColor = clear ? '#fff' : '#101f3a';

    return (
        <header ref={headerRef} className={'pb-header' + (clear ? ' is-clear' : '')}>
            <div className="pb-header-inner">
                <button onClick={() => go('top')} aria-label="Paddlers Box — home" className="pb-logo-btn">
                    <img
                        src={asset(clear ? 'assets/paddlers_box_logo_header.png' : 'assets/paddlers_box_logo_header_black_text_cropped.png')}
                        alt="Paddlers Box"/>
                </button>

                <nav className="pb-nav-wide">
                    {NAV.map(n => {
                        const active = section === n.key;
                        return (
                            <button key={n.key} onClick={() => go(n.key)} className="pb-nav-chip" style={{
                                background: active ? (clear ? 'rgba(255,255,255,0.16)' : TINT[n.color]) : 'transparent',
                                color: active ? (clear ? '#fff' : onLight(n.color)) : (clear ? 'rgba(255,255,255,0.86)' : '#3c4d68')
                            }}>
                                {n.label}
                                {active && <span className="pb-nav-dash" style={{background: n.color}}/>}
                            </button>
                        );
                    })}
                </nav>
                <button onClick={openApp} className="pb-btn-app pb-nav-wide-cta hover-brighten-lift">
                    <Icon name="phone" size={16}/>Get the app
                </button>

                <button onClick={() => setMenuOpen(!menuOpen)} aria-label="Menu" aria-expanded={menuOpen}
                        className="pb-burger" style={{borderColor: clear ? 'rgba(255,255,255,0.55)' : '#cfe0f4'}}>
                    <span style={{background: navColor}}/>
                    <span style={{background: menuOpen ? '#E4003C' : navColor}}/>
                    <span style={{background: navColor}}/>
                </button>
            </div>

            {menuOpen && (
                <nav className="pb-mobile-menu">
                    {NAV.map(n => (
                        <button key={n.key} onClick={() => go(n.key)} className="pb-mobile-link">
                            <span className="pb-mobile-dot" style={{background: GRAD[n.color], color: inkOn(n.color)}}>
                                <Icon name={n.icon} size={17}/>
                            </span>
                            {n.label}
                        </button>
                    ))}
                    <button onClick={openApp} className="pb-btn-app pb-mobile-cta hover-brighten">
                        <Icon name="phone" size={16}/>Get the app
                    </button>
                </nav>
            )}
        </header>
    );
};

export default Header;
